module.exports = __webpack_public_path__ + "fonts/Graphik-SemiboldItalic-Web.173e23c.woff";